import { useContext } from 'react';
import { DeclaracaoSaudeContext, DeclaracaoSaudeContextType } from 'context';

const useDeclaracaoSaude = (): DeclaracaoSaudeContextType =>
  useContext(DeclaracaoSaudeContext);

export default useDeclaracaoSaude;
